
import { ctaWithBgColour } from './blocks/ctaWithBgColourBlock/ctaWithBgColourBlock.widget'
import { downloadBlock } from './blocks/downloadBlock/downloadBlock.widget'
import { expandableBlock } from './blocks/expandableBlock/expandableBlock.widget'
// import { contactBlock } from './blocks/contactBlock/contactBlock.widget'
// import { factsAndFiguresBlock } from './blocks/factsAndFiguresBlock/factsAndFiguresBlock.widget'
// import { tableBlock } from './blocks/tableBlock/tableBlock.widget'
import { textReadMoreBlock } from './blocks/textReadMoreBlock/textReadMoreBlock.widget'
import { featuredContentBlock } from './blocks/featuredContentBlock/featuredContentBlock.widget'
import { linkGridBlock } from './blocks/gridBlock/gridBlock.widget'
import { highlightBlock } from './blocks/highlightBlock/highlightBlock.widget'
import { iframeBlock } from './blocks/iframeBlock/iframeBlock.widget'
import { imageTextBlock } from './blocks/imageTextBlock/imageTextBlock.widget'
import { linkListBlock } from './blocks/linkListBlock/linkListBlock.widget'
import { mediaBlock } from './blocks/mediaBlock/mediaBlock.widget'
import { quoteBlock } from './blocks/quoteBlock/quoteBlock.widget'
import { recentNewsBlock } from './blocks/recentNewsBlock/recentNewsBlock.widget'
import { textBlock } from './blocks/textBlock/textBlock.widget'
import { ModernBlock } from './modernBlocks.state'
import { logoWallBlock } from './blocks/logoWallBlock/logoWallBlock.widget'
import { donationFormBlock } from './blocks/donationFormBlock/donationFormBlock.widget'
import { jotformBlock } from './blocks/jotformBlock/jotformBlock'
import { cookieBlock } from './blocks/cookieBlock/cookieBlock.widget'
import { highlightBlockWithImage } from "./blocks/highlightBlockWithImage/highlightBlockWithImage.widget"
import { productFormBlock } from './blocks/productFormBlock/productFormBlock.widget'

export const importModernBlocks = () => {
  if (window['blockRegistered' as any]) {
    return
  }

  // DEFAULT
  registerBlock(textBlock)
  registerBlock(textReadMoreBlock)
  registerBlock(quoteBlock)
  registerBlock(ctaWithBgColour)
  registerBlock(mediaBlock)
  registerBlock(iframeBlock)
  registerBlock(imageTextBlock)
  registerBlock(downloadBlock)
  registerBlock(linkListBlock)
  registerBlock(expandableBlock)
  registerBlock(featuredContentBlock)
  registerBlock(linkGridBlock)
  registerBlock(logoWallBlock)
  // DEFAULT // NOT USED
  // registerBlock(contactBlock)
  // registerBlock(factsAndFiguresBlock)
  // registerBlock(tableBlock)
  // CUSTOM
  registerBlock(highlightBlock)
  registerBlock(highlightBlockWithImage)
  registerBlock(recentNewsBlock)
  registerBlock(donationFormBlock)
  registerBlock(productFormBlock)
  registerBlock(jotformBlock)
  registerBlock(cookieBlock)

  window['blockRegistered' as any] = true as any
}

export const registerBlock = (blockDefinition: ModernBlock<any, any, any, any>): void => {
  if (window['modernBlocks' as any] == undefined) {
    window['modernBlocks' as any] = {} as any
  }

  if (window['modernBlocks' as any][blockDefinition.kind as any] != null) {
    console.error(
      `[modernBlockImports ERROR] block with kind ${blockDefinition.kind} already exists. window[modernBlocks] will be overwritten with object.`,
      blockDefinition
    )
    alert(
      `[modernBlockImports ERROR] block with kind ${blockDefinition.kind} already exists. window[modernBlocks] will be overwritten with object. See console error for more details.`
    )
  }

  window['modernBlocks' as any][blockDefinition.kind as any] = blockDefinition as any
}
